import { Box, Typography } from "@mui/material";
import Magnifier from "../../../assets/magnifier.svg";

const headline = [
  ["A", "I", "で"],
  ["欲", "し", "い", "も", "の", "が"],
  ["す", "ぐ", "に", "見", "つ", "か", "る"],
];

export default function HeroSection() {
  return (
    <Box
      component="section"
      sx={(theme) => ({
        width: "100%",
        backgroundColor: theme.palette.primary.main,
        color: "#fff",
        position: "relative",
        overflow: "hidden",
      })}
    >
      <Box
        className="max-w-6xl mx-auto px-6"
        sx={{
          minHeight: 320,
          display: "flex",
          alignItems: "center",
        }}
      >
        {/* 左：テキストエリア */}
        <Box sx={{ zIndex: 1 }}>
          {/* 白□見出し */}
          <div className="flex flex-col gap-3 mb-6">
            {headline.map((line, rowIdx) => (
              <div key={rowIdx} className="flex gap-2">
                {line.map((char, idx) => (
                  <span
                    key={idx}
                    className="
                      inline-flex
                      items-center
                      justify-center
                      w-[44px]
                      h-[44px]
                      bg-white
                      text-[#143282]
                      font-bold
                      text-[26px]
                      leading-none
                    "
                  >
                    {char}
                  </span>
                ))}
              </div>
            ))}
          </div>

          {/* サブコピー */}
          <Typography
            variant="body1"
            sx={{
              opacity: 0.9,
              fontSize: 16,
            }}
          >
            新しいショッピング体験をあなたに
          </Typography>
        </Box>

        {/* 右：虫眼鏡 */}
        <img
          src={Magnifier}
          alt=""
          className="
            absolute
            right-[10%]
            top-1/3
            -translate-y-1/3
            w-[40%]
            max-w-[400px]
            pointer-events-none
          "
        />
      </Box>
    </Box>
  );
}
